module.exports = __webpack_public_path__ + "img/time.57879922.svg";